import React from 'react';
import StartScreen from '../../../base/components/StartScreen/StartScreen';
import ProfilePage from '../../../base/components/ProfilePage/ProfilePage';
import UserService from '../../../base/components/Keycloak/UserService';
import ModelConverterLogo from '../../../base/images/Vi_through_Logo.svg'
import MainPage from '../../../base/components/MainPage/MainPage';
import AccountIcon from '../../../base/images/account_icon.png';
import LogoutIcon from '../../../base/images/logout_icon.png';
import GermanIcon from '../../../base/images/DE_icon.png';
import EnglishIcon from '../../../base/images/EN_icon.png';
import TalsandLogo from '../../../base/images/TalsandLogo.png';
import LinkedInIcon from '../../../base/images/linkedin_icon.png';
import YouTubeIcon from '../../../base/images/youtube_icon.png';
import Dialog from '../../../base/components/Dialog/Dialog';
import { withTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import { HelperFunctions } from '../HelpferFunctions';
import { Uploader } from '../../../base/components/Uploader/Uploader';
import PrivacyInformation from '../../../base/components/Datenschutz/PrivacyInformation';
import LegalInformation from '../../../base/components/Impressum/LegalInformation';
import FAQ from '../../../base/components/faq/faq';
import { AdminHandler } from '../../../base/components/AdminHandler/AdminHandler';
import { Routes, Route, Link } from "react-router-dom";
import withRouter from '../../../with-router';
import { openEmail } from '../../../base/components/MailFunctions/MailFunctions';
import { KeycloakTalsandAPI } from '../../../base/components/Keycloak/KeycloakTalsandAPI';

const RealmHash = window.config.host.realm;
class OverlayComponents extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            username: null,
            userID: null,
            userInfo: null,
            companyID: null,
            isAdmin: false,
            modelLimit: 0,
            appAccess: false,
            coworkers: null,
            coworkersLimit: null,
            companyTfaPolicy: false,
            selectedFile: null,
            format: "gltf",
            itemID: "someid",
            language: "de",
            profilePageVisible: false,
        };
    }

    currentLocation = "/";

    componentDidMount(){
        i18n.changeLanguage("de");
        this.initialize();
    }

    initialize = () => {
      this.setState({initial: false});
      UserService.SessionData.init()
      .then(() => {
        if (UserService.SessionData.isLoggedIn()) {
          this.setState({ userID: UserService.SessionData.getUserID()});
          this.updateCurrentUser();
        }
      });

      /*
      .then((res) => {
          this.setState({username: UserService.SessionData.getUsername()});
          //this.handleLogin("admin", "talsand").then(() => this.setState({initial: false})); //NOTE: PLS leave this here, makes testing easier
      });

      UserService.AdminData.init(RealmHash);
      */
    }

    getUsername = () => {
        // return this.state.userID ?? this.state.username;
    }

    setUserID = (userID) => {
        // this.setState({ userID: userID });
    }

    generateKeycloakError(err){
      let code = "404"
      if (err.message)
        code = err.message.substring(err.message.length - 3, err.message.length);
      code = parseInt(code);
      let message = 'Keycloak-Fehler: "' + err.message + '"';
      if(code && typeof code === "number"){
          message = HelperFunctions.getKeycloakErrorMessage(code);
      }
      return message;
    }

    onLoginCallbacks = [];

    handleLogin = (username, password) => {
        const self = this;
        this.setState({ username: username });
        return new Promise((resolve, reject) =>
            UserService.SessionData.login(username, password)
                .then((res) => {
                    self.setState({ userID: UserService.SessionData.getUserID()});
                    self.updateCurrentUser();

                    resolve(res);
                }).catch((err) => {
                    reject(err)
                })
        );
    }

    remUser(useridx)
    {
      const { t } = this.props;
      const self = this;
      var username = this.state.coworkers[useridx].UserEmail;
      Dialog.Alert({
        title: t('RemUser') + " " + username,
        description: t('RemUserSure'),
        options: [
          {label: t('Delete'), className:"dangerConfirm"},
          {label: t('Cancel'), className:""},
        ],
        panelOptions: {className: "vithrough"}
        }).then((optionChosen) => {
          if (optionChosen === 0) {
            var userid = this.state.coworkers[useridx].UserGuid;
            AdminHandler.remUser(userid)
            .then((res) => {
                var currCompanyID = UserService.SessionData.currentUserInfo.attributes['CompanyID'][0];
                Uploader.getCoworkers(RealmHash, currCompanyID).then((res) =>{
                    self.setState({coworkers: res.data});
                })
            })
            .catch((err) =>
            {
            })
          }
        });
    }

    updateCurrentUser()
    {
        //Update Keycloak User
        const self = this;
        UserService.AdminData.getCurrentUserInfo().then((res) =>{

            var currCompanyID = UserService.SessionData.currentUserInfo.attributes['CompanyID'][0];
            var username = UserService.SessionData.currentUserInfo.firstName; //+ " " + UserService.SessionData.currentUserInfo.lastName != null ? UserService.SessionData.currentUserInfo.lastName : ""
            var currUserInfo = [UserService.SessionData.currentUserInfo.email, username, UserService.SessionData.currentUserInfo.attributes['Company'][0], UserService.SessionData.currentUserInfo.attributes['TOTP'] ? UserService.SessionData.currentUserInfo.attributes['TOTP'][0] : "0"];
            var admin = (UserService.SessionData.currentUserInfo.attributes['Admin'] != null);
            self.setState({companyID: currCompanyID, userInfo: currUserInfo, isAdmin: admin});
            //Update FileLimit
            Uploader.getFileLimit(RealmHash, currCompanyID).then((res) =>{
                var newLimit = res.data['ModelLimit'];
                var newAccess = res.data['AppAccess'];
                var newUserLimit = res.data['UserLimit'];
                var newTfaPolicy = res.data['TFA'];
                self.setState({modelLimit: newLimit, appAccess: newAccess, coworkersLimit: newUserLimit, companyTfaPolicy: newTfaPolicy});
            })
            .catch((err) =>{

            });
            //Update Coworkers
            Uploader.getCoworkers(RealmHash, currCompanyID).then((res) =>{
                self.setState({coworkers: res.data});
            })
            .catch((err) =>{

            });
        })
        .catch((err) =>{

        });
    }

    handleLogout(){
      Dialog.Alert({
          title: "Log out",
          description: "Wollen Sie sich wirklich ausloggen?",
          options: [
              {label: "Ausloggen", className:"dangerConfirm"},
              {label: "Abbrechen", className:""},
          ],
          panelOptions: {className: "vithrough"},
      }).then((optionChosen) => {
          if (optionChosen === 0) {
            document.body.style.overflowX = "hidden"; document.body.style.overflowY = "auto";
              return new Promise((resolve,reject) =>{
                  UserService.SessionData.logout().then((res) => {
                      this.setState({username: null,profilePageVisible: false});
                      resolve(res);
                  }).catch((err) => {
                      reject(err);
                  })
              })
          }
      })
    }

    handlePasswortReset()
    {
      const { t } = this.props;
      Dialog.Alert({
        title: t('ResetPassword'),
        description: t('ResetPasswordSure'),
        options: [
            {label: t('Reset'), className:"dangerConfirm"},
            {label: t('Cancel'), className:""},
        ],
        panelOptions: {className: "vithrough"},
    }).then((res) => {
        if (res === 0) {
            KeycloakTalsandAPI.ResetPassword(UserService.SessionData.currentUserInfo.email, RealmHash)
            .then((resp) => {
                Dialog.Alert({
                  title: t('ResetPassword'),
                  description: t('ResetMailMessage'),
                  options: [
                  {label: t('OK'), className:""},
                  ],
                  panelOptions: {className: "vithrough oneButtonDialog"},
                })
            })
            .catch((err) => {
                let message = this.generateKeycloakError(err);
                Dialog.Alert({
                    title: "Fehler beim zurücksetzen des Passworts. Bitte laden Sie die Seite neu und versuchen es erneut. Sollte das Problem weiterhin bestehen, kontaktieren Sie die zuständige Partei.",
                    description: message,
                    options: [
                        {label: t('OK'), className:""},
                    ],
                    panelOptions: {className: "vithrough oneButtonDialog"}
                })
            })
        }
    })
    }

    toggleLanguage = () =>{
        if(i18n.language === "en"){
            i18n.changeLanguage("de");
            this.setState({language: "de"});
        }else{
            i18n.changeLanguage("en");
            this.setState({language: "en"});
        }
    }

    toggleProfilePage()
    {
      this.setState({profilePageVisible: false});
    }

    render() {
        const { t } = this.props;

        var myself = (this.state.coworkers != null && this.state.userInfo != null && this.state.userInfo[0] != null) ? this.state.coworkers.find((w) => w.UserEmail === this.state.userInfo[0]) : null;
        var canEdit = myself != null ? myself.UserRole < 3 : false;
        if (this.currentLocation !== this.props.router.location.pathname)
        {
          this.currentLocation = this.props.router.location.pathname;
          window.scrollTo(0, 0);
          document.body.style.overflowX = "hidden"; document.body.style.overflowY = "auto";
        }
        return (

            <div className='overlay'>
              <Dialog/>
                <div className='overlay_header'>
                    <Link to="/"><img alt='logo' src={ModelConverterLogo}/></Link>
                    <div className='overlay_header_buttons'>
                        <div className='menu_bar'>
                          <Link to={this.props.router.location.pathname === "/faq" ? "/" : "/faq"} style={{color: this.props.router.location.pathname === "/faq" ? "#000": "#fff"}}>FAQ</Link>
                        </div>
                      <button className='language_switch' onClick={() => this.toggleLanguage()} title={t('Hover_LangSwitch')}><img alt="" src={i18n.language === "en" ? EnglishIcon : GermanIcon}/></button>
                      { UserService.SessionData.currentUser != null && <div className='overlay_vr_line'/> }
                      { UserService.SessionData.currentUser != null &&
                        <button onClick={() => this.setState({profilePageVisible: !this.state.profilePageVisible})} title={t('Hover_Profile')}><img alt="" className={this.state.profilePageVisible? "invertedimg" : ""} src={AccountIcon}/></button>
                      }
                      { UserService.SessionData.currentUser != null &&
                        <div className='overlay_vr_line'/>
                      }
                      { UserService.SessionData.currentUser != null &&
                        <button onClick={() => this.handleLogout()} title="Logout"><img alt="" src={LogoutIcon}/></button>
                      }
                    </div>
                </div>
              {UserService.SessionData.currentUser != null &&
                <ProfilePage
                  profilePageActive={this.state.profilePageVisible}
                  userInfo={this.state.userInfo}
                  userID={this.state.userID}
                  coworkers={this.state.coworkers}
                  coworkersLimit={this.state.coworkersLimit}
                  companyTfaPolicy={this.state.companyTfaPolicy}
                  remUser={(idx) => this.remUser(idx)}
                  closeProfilePage={() => this.toggleProfilePage()}
                  handlePasswortReset={() => this.handlePasswortReset()}
                  updateCurrentUser={() => this.updateCurrentUser()}
                />
              }
              <div className='overlay_body'>
                <Routes>
                 <Route index path="/"
                 element={
                  UserService.SessionData.currentUser == null ?
                  <StartScreen
                    initialMode="login"
                    initialShow = {true}
                    onDiscard={() => {this.goToMain()}}
                    onLogin={(username, password) => this.handleLogin(username, password)}
                  />
                  :
                  <MainPage
                    realm = {RealmHash}
                    companyID = {this.state.companyID}
                    canEdit = {canEdit}
                    userID={this.state.userID}
                    isCompanyAdmin= {canEdit}
                    fileSpaces = {this.state.modelLimit}
                    appAccess = {this.state.appAccess}
                    isAdmin = {this.state.isAdmin}
                    onClickShowFAQ={() => this.props.router.navigate("/faq")}
                    onUpdateCompanyUserLimit={(companyGUID) => {
                      if(companyGUID === this.state.companyID){
                        this.updateCurrentUser()
                      }
                    }}
                  />
                 }/>
                 <Route path="/legal"
                 element={
                  <LegalInformation
                  />
                }/>
                 <Route path="/privacy"
                 element={
                  <PrivacyInformation/>
                  }
                  />
                  <Route path="/faq"
                  element={<FAQ
                    goToMain={() => this.props.router.navigate("/")}
                  />}
                  />
                </Routes>

              {
                this.state.mode === "legal" &&
                <LegalInformation/>
              }
              {
                this.state.mode === "privacy" &&
                <PrivacyInformation/>

              }
              </div>
              <div className='overlay_footer' id='Footer_Height'>
                <div className='overlay_hr_line'/>
                <div className='footer_elements'>
                    <a className='footer_element' id='Footer1' href="https://talsand.eu/ar-sales-tool/" rel="noreferrer" target="_blank">
                        {t('Product')}
                        <div><img alt="talsand" src={TalsandLogo}/></div>
                    </a>
                    <div className='footer_element' id='Footer2'>
                        <Link to="/legal">{t('LegalInformation')}</Link>
                        <Link to="/privacy">{t('ProtectionOfPrivacy')}</Link>
                        <Link to="/faq">{t('FAQ')}</Link>
                    </div>
                    <div className='footer_element' id='Footer22'>
                        <label>{t('Talsand_Adress')}</label>
                        <label>
                          <label className='mail_contact' title={t('Talsand_Contact')} onClick={() => openEmail(t('Talsand_Contact'), t('Talsand_Contact_Subject'))}>{t('Talsand_Contact')}</label>
                          <a href="https://talsand.eu/" rel="noreferrer" target="_blank"><label> | Web: talsand.eu</label></a>
                        </label>
                        <div className='overlay_hr_line_impressum'></div>
                        <div className='sm_icons'>
                            <a href="https://www.linkedin.com/company/talsand/" rel="noreferrer" target="_blank"><button title='LinkedIn' className='Footer3'><img alt="" src={LinkedInIcon}/></button></a>
                            <a href="https://youtube.com/@Vithrough_AR?si=phF8tmtSK6rq-aQ4" rel="noreferrer" target="_blank"><button title='Youtube' className='Footer3'><img alt="" src={YouTubeIcon}/></button></a>
                        </div>
                    </div>
                </div>
              </div>
        </div>
        );
    }
}

export default withRouter(withTranslation()(OverlayComponents));
